<template>
	<div>
		<AppHeader title="마이페이지"></AppHeader>
		<AppContent>
			<MyPageDetail />
		</AppContent>
		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppFooter from '@/components/common/AppFooter';
import AppContent from '@/components/common/AppContent';

import MyPageDetail from '@/components/MyPageDetail.vue';

export default {
	components: {
		AppHeader,
		AppFooter,
		AppContent,
		MyPageDetail,
	},
};
</script>
